import Edit from 'components/assets/actions/AssetsEdit';
import SendTokenAsign from 'components/assets/actions/AssetsSendTokenAsign';
import RequestUpdate from 'components/assets/actions/AssetsRequestUpdate';
import Disable from 'components/assets/actions/AssetsActionsDisable';
import Enable from 'components/assets/actions/AssetsActionsEnable';
import Detail from 'components/assets/actions/AssetsActionsDetail';

export default { Edit, SendTokenAsign, Disable, Enable, Detail, RequestUpdate };



// WEBPACK FOOTER //
// src/components/assets/actions/index.js